/**
 * Zest Logo component — used across all pages for consistent branding.
 * Renders the logo image in a dark rounded container.
 */

const LOGO_URL = "/zest-logo.png";

export function ZestLogo({ height = "h-7", className = "" }) {
  return (
    <img src={LOGO_URL} alt="Zest" className={`${height} w-auto object-contain ${className}`} />
  );
}
